import React from 'react';
// @ts-ignore
import ImatgeComponent from 'components/corporatiu/Imatge';
import styles from './donatiumarato.module.scss';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';
import type { DonatiuMaratoProps } from './DonatiuMarato.types';

const Imatge = ImatgeComponent as React.ComponentType<{
    src: string;
    alt: string;
    width: number;
    height: number;
    className?: string;
}>;

const Boto = BotoComponent as React.ComponentType<{
    link?: string;
    className?: string;
    tema?: string;
    text?: string;
    icona?: string;
}>;

const DonatiuMarato: React.FC<DonatiuMaratoProps> = ({ edicio, mostraTelefon }) => {
    return (
        <>
            <p>Escull la modalitat que et vagi millor per fer la teva aportació per La Marató {edicio}:</p>
            <div className={styles.wrapper}>
                <div className={styles.item}>
                    <div className={styles.titol}>Per internet:</div>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/donatius/icona-perinternet.svg'
                        alt='per Internet'
                        width={70}
                        height={70}
                        className={styles.itemImage}
                    />
                    <div>
                        <Boto
                            link='https://www.caixabank.es/apl/donativos/detalle_ca.html?DON_codigoCausa=526'
                            className={styles.boto}
                            tema='maratoCTA'
                            text='Fes el teu donatiu'
                            icona='fletxa_simple_dreta'
                        />
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.titol}>
                        Per Bizum, des de l&apos;apartat &quot;Donacions&quot;, amb l&apos;identificador de La Marató:
                        <strong> 33333</strong>
                    </div>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/donatius/icona-Bizum.svg'
                        alt='Bizum'
                        width={71}
                        height={71}
                        className={styles.itemImage}
                    />
                    <p className={styles.textTerciari}>
                        Per complir amb les obligacions legals, anota el teu codi postal al camp &quot;concepte&quot; de
                        l&apos;aplicació.
                    </p>
                </div>
                <div className={styles.item}>
                    <div className={styles.titol}>Per transferència bancària:</div>
                    <Imatge
                        src='https://statics.3cat.cat/recursos/marato/img/donatius/icona-transferencia.svg'
                        alt='per transferència'
                        width={72}
                        height={72}
                        className={styles.itemImage}
                    />
                    <p className='gapAfter'>
                        Número de compte:
                        <span>
                            <br />
                            ES94 2100 0555 34 0202122222
                        </span>
                    </p>
                    <p className='gapAfter'>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/marato/img/donatius/icona-transf-estranger.svg'
                            alt="transferència des de l'estranger"
                            width={33}
                            height={33}
                        />
                        Des de l&apos;estranger - BIC/ SWIFT CODE:
                        <br />
                        <strong>CAIXESBBXXX</strong>
                    </p>
                    <p>
                        Per ingressar la recaptació de les
                        <strong> Entitats que hagin inscrit una activitat popular</strong>, utilitzar el número de compte:
                        <br />
                        <strong> ES55 2100 0555 37 0201474332</strong>
                    </p>
                </div>
                {mostraTelefon && (
                    <div className={styles.item}>
                        <div className={styles.titol}>Per telèfon:</div>
                        <Imatge
                            src='https://statics.3cat.cat/recursos/marato/img/donatius/icona-telefon.svg'
                            alt='per telèfon'
                            width={70}
                            height={70}
                            className={styles.itemImage}
                        />
                        <p className='gapAfter'>
                            <strong>
                                <a href='tel:+34900215050'>900 21 50 50</a>
                            </strong>
                        </p>
                        <p>Només el dia de La Marató</p>
                    </div>
                )}
            </div>
            <div>
                <div className={styles.legal}>
                    <p className={styles.textSecundari}>
                        En compliment de la legislació actual i per poder fer efectiu el donatiu a la Fundació la Marató de 3Cat i
                        rebre el certificat corresponent, serà imprescindible que complimenti aquest formulari abans del 31 de
                        desembre.
                    </p>
                    <Boto
                        link='https://registre-lamarato.3cat.cat/lamarato/peticio-certificat-fiscal.jsf'
                        className={styles.boto}
                        tema='marato'
                        text='Petició del certificat'
                    />
                    <p className={styles.textTerciari}>
                        <em>
                            Informem que el termini legal que té la Fundació La Marató de 3Cat per declarar les donacions rebudes
                            finalitza el dia 31 de gener. Per poder gestionar correctament la declaració fiscal dins del termini
                            agrairem que faci la petició del certificat acreditatiu abans del 31 de desembre.
                        </em>
                    </p>

                    <Text
                        text={
                            "Més informació a <a target='_blank' href='https://www.3cat.cat/avis-legal/privacitat/fundacio-la-marato/'>3cat.cat/avis-legal/privacitat/fundacio-la-marato/</a>"
                        }
                        tag='p'
                        className={styles.textTerciari}
                    />
                    <Text
                        text={
                            "Vols rebre informació de <a target='_blank' href='/tv3/marato/dades/'>Fundació La Marató de 3Cat</a>?"
                        }
                        tag='p'
                        className={styles.textTerciari}
                    />
                </div>
                <aside className={styles.textLegal}>
                    <h2>Fundacions acollides a la llei 49/2002</h2>
                    <p>
                        La Fundació La Marató de 3Cat és una entitat sense finalitat lucrativa a efectes de la Llei 49/2002, de 23
                        de desembre, de Règim Fiscal de les entitats sense finalitats lucratives i dels incentius fiscals al
                        mecenatge.
                    </p>
                    <p>
                        Per tant, els donatius efectuats en benefici d&apos;aquesta Fundació donen dret a practicar les següents
                        deduccions:
                    </p>
                    <p>
                        <strong>A partir de l&apos;1 de gener de 2024</strong>
                    </p>
                    <ul>
                        <li>
                            <p>
                                <strong>Impost sobre la Renda de les Persones Físiques (persona física):</strong>
                            </p>
                            <ul>
                                <li>
                                    <p>
                                        A partir de l&apos;1 de gener de 2024, el percentatge de deducció serà del 80% per als
                                        primers 250€ i, per a la resta, del 40%.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        Donacions recurrents: si en els dos exercicis anteriors s&apos;han fet donacions a favor
                                        de la Fundació La Marató de 3Cat per un import igual o superior, en cada un d&apos;aquests
                                        exercicis, al de l&apos;exercici anterior, el percentatge de deducció aplicable a la base
                                        de la deducció que excedeix de 250 € serà del 45%.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        La base de la deducció no podrà excedir el 10% de la base liquidable. Les quantitats no
                                        aplicades per insuficiència de quota o perquè sobrepassen el límit del 10% no són
                                        traslladables a exercicis futurs
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <p>
                                <strong>Impost sobre Societats (persona jurídica):</strong>
                            </p>
                            <ul>
                                <li>
                                    <p>El percentatge de deducció serà del 40% de la base de la deducció.</p>
                                </li>
                                <li>
                                    <p>
                                        Donacions recurrents: si en els dos exercicis anteriors s&apos;han fet donacions a favor
                                        de la Fundació La Marató de 3Cat per un import igual o superior, en cada un d&apos;aquests
                                        exercicis, al de l&apos;exercici anterior, el percentatge de deducció aplicable a la base
                                        de la deducció serà del 50%.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        La base de la deducció no podrà excedir el 15% de la base imposable. Les quantitats no
                                        aplicades per insuficiència de quota o perquè sobrepassen el límit del 15% podran
                                        aplicar-se a les liquidacions dels períodes impositius que concloguin en els 10 anys
                                        immediats i successius.
                                    </p>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </aside>
            </div>
        </>
    );
};

export default DonatiuMarato;
